export class ResetState {
  static readonly type = '[DocumentDistribute] Reset State';
  constructor() {}
}

export class AddDocument {
  static readonly type = '[DocumentDistribute] Add Document';
  constructor(public document: any) {}
}

export class RemoveDocument {
  static readonly type = '[DocumentDistribute] Remove Document';
  constructor(public docID: string) {}
}

export class AddFiling {
  static readonly type = '[DocumentDistribute] Add Filing';
  constructor(public docID: string, public filing: any) {}
}

export class RemoveFiling {
  static readonly type = '[DocumentDistribute] Remove Filing';
  constructor(public docID: string, public docLinkID: string) {}
}

export class RemoveAllFilingsForDocID {
  static readonly type = '[DocumentDistribute] Remove All Filings For DocID';
  constructor(public docID: string) {}
}

export class UpdateDocument {
  static readonly type = '[DocumentDistribute] Update Document';
  constructor(public document: any) {}
}

export class UpdateDocumentID {
  static readonly type = '[DocumentDistribute] Update Document ID';
  constructor(public docID: string, public newDocID: string) {}
}

export class UpdateFiling {
  static readonly type = '[DocumentDistribute] Update Filing';
  constructor(public filing: any) {}
}

export class AddFilingItem {
  static readonly type = '[DocumentDistribute] Add Filing Item';
  constructor(public docID: string, public docLinkID: string) {}
}

export class RemoveFilingItem {
  static readonly type = '[DocumentDistribute] Remove Filing Item';
  constructor(public docID: string, public docLinkID: string) {}
}

export class AddCorrespondOptions {
  static readonly type = '[DocumentDistribute] Add Correspond Options';
  constructor(public correspondOptions: any) {}
}

export class UpdateCorrespondOptions {
  static readonly type = '[DocumentDistribute] Update Correspond Options';
  constructor(public correspondOptions: any) {}
}

export class SetCorrespondTemplates {
  static readonly type = '[DocumentDistribute] Set Correspond Templates';
  constructor(public correspondTemplates: any) {}
}
